module.exports = __webpack_public_path__ + "43c1fa0cf2797dfc31a799ff1c3bd16b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-19.png
// module id = 2970
// module chunks = 0